export const DEFAULT_PORTAL_TITLE =
  process.env.REACT_APP_PORTAL_TITLE || "AEIG Portal";
